import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from './pages/login';
import SuperadminLogin from './pages/SuperadminLogin';
import Dashboard from './pages/Dashboard';
import AgendamentoForm from './components/AgendamentoForm';
import ServicosForm from "./components/ServicosForm";
import CriarFolga from "./components/CriarFolga";
import AgendamentosConcluidos from "./components/AgendamentosConcluidos";
import ExcluirHorarios from "./components/ExcluirHorarios";
import AlterarSenha from "./pages/AlterarSenha";
import GerenciamentoDeHorarios from "./components/GerenciamentoDeHorarios";
import GerenciarHorarios from "./components/GerenciarHorarios";
import AdicionarBarbearia from "./pages/System";
import Configuracoes2FA from "./components/Configuracoes2FA";
import Configuracoes2FAcl from "./components/Configuracoes2FAcl";
import DashboardAdmin from "./pages/DashboardAdmin";
import UploadFotoFuncionario from "./components/UploadFotoFuncionario";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/acesso-superadmin" element={<SuperadminLogin />} />

        {/* Rotas comuns */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard-admin" element={<DashboardAdmin />} />
        <Route path="/agendamentos/new" element={<AgendamentoForm />} />
        <Route path="/agendamentos/edit/:id" element={<AgendamentoForm />} />
        <Route path="/servicos/new" element={<ServicosForm />} />
        <Route path="/folgas/new" element={<CriarFolga />} />
        <Route path="/excluir_horarios/new" element={<ExcluirHorarios />} />
        <Route path="/gerenciar_horarios" element={<GerenciamentoDeHorarios />} />
        <Route path="/gerenciar_horarios_funcionamento" element={<GerenciarHorarios />} />
        <Route path="/agendamentos/concluidos/new" element={<AgendamentosConcluidos />} />
        <Route path="/alterar-senha" element={<AlterarSenha />} />
        <Route path="/upload-foto" element={<UploadFotoFuncionario />} />

        {/* Rota de superadmin */}
        <Route path="/sistema/gerenciamento" element={<AdicionarBarbearia />} />

        {/* Rotas para configurações do 2FA */}
        <Route path="/sistema/configuracoes-2fa" element={<Configuracoes2FA />} />
        <Route path="/cl13nt/configuracoes-2fa" element={<Configuracoes2FAcl />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;